var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "dice",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 9",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dice__d6",
    d: "M 1.5 1.5 L 7.5 1.5 L 7.5 7.5 L 1.5 7.5 L 1.5 1.5 L 7.5 1.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD6);
export default __webpack_public_path__ + "static/media/d6.3279a47b3764bb698549f88a6565b587.svg";
export { ForwardRef as ReactComponent };